export enum ExportFileType {
  Word = 0,
  Excel = 1,
}
